import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';

/**
 * Base Home product pricing by store/region
 */
export const HomePrice: Record<ShopifyStore, number> = {
  // [ShopifyStore.IN]: 34999,
  // [ShopifyStore.ROW]: 399,
  // [ShopifyStore.US]: 399,
  // [ShopifyStore.EU]: 429,
  // [ShopifyStore.GB]: 379,
  // [ShopifyStore.AE]: 1489,
  // [ShopifyStore.AU]: 699,
  // [ShopifyStore.CA]: 549,
  // [ShopifyStore.SA]: 1729,
  // [ShopifyStore.MX]: 8509,
  // [ShopifyStore.ZA]: 6499,
  [ShopifyStore.IN]: 54999,
  [ShopifyStore.ROW]: 549,
  [ShopifyStore.US]: 549,
  [ShopifyStore.EU]: 579,
  [ShopifyStore.GB]: 489,
  [ShopifyStore.AE]: 1999,
  [ShopifyStore.AU]: 849,
  [ShopifyStore.CA]: 769,
  [ShopifyStore.SA]: 2369,
  [ShopifyStore.MX]: 9189,
  [ShopifyStore.ZA]: 8999,
  [ShopifyStore.JP]: 88000,
};

/**
 * Original (striked through) prices for when discounts are applied
 */
export const HomePriceStriked: Record<ShopifyStore, number> = {
  [ShopifyStore.IN]: 54999,
  [ShopifyStore.ROW]: 549,
  [ShopifyStore.US]: 549,
  [ShopifyStore.EU]: 579,
  [ShopifyStore.GB]: 489,
  [ShopifyStore.AE]: 1999,
  [ShopifyStore.AU]: 849,
  [ShopifyStore.CA]: 769,
  [ShopifyStore.SA]: 2369,
  [ShopifyStore.MX]: 9189,
  [ShopifyStore.ZA]: 8999,
  [ShopifyStore.JP]: 88000,
};

/**
 * Main product data including SKUs and variant IDs
 */
export const PRODUCT_MAP_STAGING = {
  id: 'home-smart-home-device',
  name: 'Ultrahuman Home',
  description: 'Smart home monitoring system for health and wellness',
  SKU: 'HOME-BASE-01',
  variantId: {
    [ShopifyStore.IN]: 'gid://shopify/ProductVariant/54343900332105',
    [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/54343900332105',
    [ShopifyStore.US]: 'gid://shopify/ProductVariant/54343900332105',
    [ShopifyStore.SA]: 'gid://shopify/ProductVariant/54343900332105',
    [ShopifyStore.MX]: 'gid://shopify/ProductVariant/54343900332105',
    [ShopifyStore.EU]: 'gid://shopify/ProductVariant/54343900332105',
    [ShopifyStore.GB]: 'gid://shopify/ProductVariant/54343900332105',
    [ShopifyStore.AE]: 'gid://shopify/ProductVariant/54343900332105',
    [ShopifyStore.AU]: 'gid://shopify/ProductVariant/54343900332105',
    [ShopifyStore.CA]: 'gid://shopify/ProductVariant/54343900332105',
    [ShopifyStore.ZA]: 'gid://shopify/ProductVariant/54343900332105',
    [ShopifyStore.JP]: 'gid://shopify/ProductVariant/54343900332105',
  },
  checkoutUrl: {
    [ShopifyStore.IN]:
      'https://ultrahumanstore.myshopify.com/cart/54343900332105:1?channel=buy_button',
    [ShopifyStore.AE]:
      'https://ultrahuman-mena.myshopify.com/cart/54343900332105:1?channel=buy_button',
    [ShopifyStore.ROW]:
      'https://ultrahuman-us.myshopify.com/cart/54343900332105:1?channel=buy_button',
    [ShopifyStore.GB]:
      'https://ultrahuman-eu-uk.myshopify.com/cart/54343900332105:1?channel=buy_button',
    [ShopifyStore.US]:
      'https://stelcore-x-ultrahuman.myshopify.com/cart/54343900332105:1?channel=buy_button',
    [ShopifyStore.EU]:
      'https://ultrahuman-eu-uk.myshopify.com/cart/54343900332105:1?channel=buy_button',
    [ShopifyStore.AU]:
      'https://ultrahuman-eu-uk.myshopify.com/cart/54343900332105:1?channel=buy_button',
    [ShopifyStore.CA]:
      'https://stelcore-x-ultrahuman.myshopify.com/cart/54343900332105:1?channel=buy_button',
    [ShopifyStore.SA]:
      'https://ultrahuman-eu-uk.myshopify.com/cart/54343900332105:1?channel=buy_button',
    [ShopifyStore.MX]:
      'https://ultrahuman-eu-uk.myshopify.com/cart/54343900332105:1?channel=buy_button',
    [ShopifyStore.ZA]:
      'https://ultrahuman-eu-uk.myshopify.com/cart/54343900332105:1?channel=buy_button',
    [ShopifyStore.JP]:
      'https://ultrahuman-eu-uk.myshopify.com/cart/54343900332105:1?channel=buy_button',
  },
  taxesInclusion: {
    [ShopifyStore.IN]: true,
    [ShopifyStore.ROW]: false,
    [ShopifyStore.US]: false,
    [ShopifyStore.EU]: true,
    [ShopifyStore.GB]: true,
    [ShopifyStore.AE]: false,
    [ShopifyStore.AU]: true,
    [ShopifyStore.CA]: false,
    [ShopifyStore.SA]: false,
    [ShopifyStore.MX]: false,
    [ShopifyStore.ZA]: false,
    [ShopifyStore.JP]: true,
  },
  // Image URLs (using Next.js optimized image loading)
  images: [
    {
      src: '/images/home/main.jpg',
      alt: 'Ultrahuman Home device',
      width: 1200,
      height: 800,
    },
    {
      src: '/images/home/angle.jpg',
      alt: 'Ultrahuman Home side angle',
      width: 1200,
      height: 800,
    },
    {
      src: '/images/home/lifestyle.jpg',
      alt: 'Ultrahuman Home in living room',
      width: 1200,
      height: 800,
    },
  ],
  features: [
    'Advanced air quality monitoring',
    'Sleep environment optimization',
    'Smart home integration',
    'Real-time health insights',
    'Voice control capabilities',
  ],
  // SEO metadata
  seo: {
    title: 'Ultrahuman Home | Smart Home Health Monitoring',
    description:
      'Transform your living space with the Ultrahuman Home. Monitor air quality, optimize sleep, and gain health insights.',
    keywords: [
      'smart home',
      'health monitoring',
      'air quality',
      'sleep optimization',
    ],
  },
};

const PRODUCT_MAP = {
  id: 'home-smart-home-device',
  name: 'Ultrahuman Home',
  description: 'Smart home monitoring system for health and wellness',
  SKU: 'HOME-BASE-01',
  variantId: {
    [ShopifyStore.IN]: 'gid://shopify/ProductVariant/41934337900614',
    [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/41655829069884',
    [ShopifyStore.US]: 'gid://shopify/ProductVariant/42330595262560',
    [ShopifyStore.SA]: 'gid://shopify/ProductVariant/50084719198526',
    [ShopifyStore.EU]: 'gid://shopify/ProductVariant/50084719198526',
    [ShopifyStore.GB]: 'gid://shopify/ProductVariant/50084719198526',
    [ShopifyStore.AE]: 'gid://shopify/ProductVariant/46419396788466',
    [ShopifyStore.AU]: 'gid://shopify/ProductVariant/50084719198526',
    [ShopifyStore.MX]: 'gid://shopify/ProductVariant/50084719198526',
    [ShopifyStore.CA]: 'gid://shopify/ProductVariant/42330595262560',
    [ShopifyStore.ZA]: 'gid://shopify/ProductVariant/50084719198526',
    [ShopifyStore.JP]: 'gid://shopify/ProductVariant/50084719198526',
  },
  checkoutUrl: {
    [ShopifyStore.IN]:
      'https://ultrahumanstore.myshopify.com/cart/41934337900614:1?channel=buy_button',
    [ShopifyStore.AE]:
      'https://ultrahuman-mena.myshopify.com/cart/46419396788466:1?channel=buy_button',
    [ShopifyStore.ROW]:
      'https://ultrahuman-us.myshopify.com/cart/41655829069884:1?channel=buy_button',
    [ShopifyStore.GB]:
      'https://ultrahuman-eu-uk.myshopify.com/cart/50084719198526:1?channel=buy_button',
    [ShopifyStore.US]:
      'https://stelcore-x-ultrahuman.myshopify.com/cart/42330595262560:1?channel=buy_button',
    [ShopifyStore.EU]:
      'https://ultrahuman-eu-uk.myshopify.com/cart/50084719198526:1?channel=buy_button',
    [ShopifyStore.AU]:
      'https://ultrahuman-eu-uk.myshopify.com/cart/50084719198526:1?channel=buy_button',
    [ShopifyStore.CA]:
      'https://stelcore-x-ultrahuman.myshopify.com/cart/42330595262560:1?channel=buy_button',
    [ShopifyStore.MX]:
      'https://ultrahuman-eu-uk.myshopify.com/cart/50084719198526:1?channel=buy_button',
    [ShopifyStore.ZA]:
      'https://ultrahuman-eu-uk.myshopify.com/cart/50084719198526:1?channel=buy_button',
    [ShopifyStore.JP]:
      'https://ultrahuman-eu-uk.myshopify.com/cart/50084719198526:1?channel=buy_button',
  },
  taxesInclusion: {
    [ShopifyStore.IN]: true,
    [ShopifyStore.ROW]: false,
    [ShopifyStore.US]: false,
    [ShopifyStore.EU]: true,
    [ShopifyStore.GB]: true,
    [ShopifyStore.AE]: false,
    [ShopifyStore.AU]: true,
    [ShopifyStore.CA]: false,
    [ShopifyStore.SA]: true,
    [ShopifyStore.MX]: true,
    [ShopifyStore.ZA]: false,
    [ShopifyStore.JP]: true,
  },
  // Image URLs (using Next.js optimized image loading)
  images: [
    {
      src: '/images/home/main.jpg',
      alt: 'Ultrahuman Home device',
      width: 1200,
      height: 800,
    },
    {
      src: '/images/home/angle.jpg',
      alt: 'Ultrahuman Home side angle',
      width: 1200,
      height: 800,
    },
    {
      src: '/images/home/lifestyle.jpg',
      alt: 'Ultrahuman Home in living room',
      width: 1200,
      height: 800,
    },
  ],
  features: [
    'Advanced air quality monitoring',
    'Sleep environment optimization',
    'Smart home integration',
    'Real-time health insights',
    'Voice control capabilities',
  ],
  // SEO metadata
  seo: {
    title: 'Ultrahuman Home | Smart Home Health Monitoring',
    description:
      'Transform your living space with the Ultrahuman Home. Monitor air quality, optimize sleep, and gain health insights.',
    keywords: [
      'smart home',
      'health monitoring',
      'air quality',
      'sleep optimization',
    ],
  },
};

export const productMap_home =
  process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
    ? PRODUCT_MAP
    : PRODUCT_MAP_STAGING;

/**
 * Add-on options for Home
 */
export const HomeAddonShopifyMap = {
  [ShopifyStore.IN]: {
    Year1: {
      id: 'home-1y-extension-in',
      name: 'Home 1-Year Extension',
      description: 'Extend your coverage for an additional year',
      price: 4999,
      variantId: 'gid://shopify/ProductVariant/40123456789013',
      SKU: 'HOME-EXT-1Y-IN',
    },
    Year2: {
      id: 'home-2y-extension-in',
      name: 'Home 2-Year Extension',
      description: 'Extend your coverage for two additional years',
      price: 8999,
      variantId: 'gid://shopify/ProductVariant/40123456789014',
      SKU: 'HOME-EXT-2Y-IN',
    },
  },
  [ShopifyStore.ROW]: {
    Year1: {
      id: 'home-1y-extension-row',
      name: 'Home 1-Year Extension',
      description: 'Extend your coverage for an additional year',
      price: 59,
      variantId: 'gid://shopify/ProductVariant/40234567890124',
      SKU: 'HOME-EXT-1Y-ROW',
    },
    Year2: {
      id: 'home-2y-extension-row',
      name: 'Home 2-Year Extension',
      description: 'Extend your coverage for two additional years',
      price: 99,
      variantId: 'gid://shopify/ProductVariant/40234567890125',
      SKU: 'HOME-EXT-2Y-ROW',
    },
  },
  [ShopifyStore.US]: {
    Year1: {
      id: 'home-1y-extension-us',
      name: 'Home 1-Year Extension',
      description: 'Extend your coverage for an additional year',
      price: 59,
      variantId: 'gid://shopify/ProductVariant/40345678901235',
      SKU: 'HOME-EXT-1Y-US',
    },
    Year2: {
      id: 'home-2y-extension-us',
      name: 'Home 2-Year Extension',
      description: 'Extend your coverage for two additional years',
      price: 99,
      variantId: 'gid://shopify/ProductVariant/40345678901236',
      SKU: 'HOME-EXT-2Y-US',
    },
  },
  [ShopifyStore.EU]: {
    Year1: {
      id: 'home-1y-extension-eu',
      name: 'Home 1-Year Extension',
      description: 'Extend your coverage for an additional year',
      price: 59,
      variantId: 'gid://shopify/ProductVariant/40456789012346',
      SKU: 'HOME-EXT-1Y-EU',
    },
    Year2: {
      id: 'home-2y-extension-eu',
      name: 'Home 2-Year Extension',
      description: 'Extend your coverage for two additional years',
      price: 99,
      variantId: 'gid://shopify/ProductVariant/40456789012347',
      SKU: 'HOME-EXT-2Y-EU',
    },
  },
  [ShopifyStore.GB]: {
    Year1: {
      id: 'home-1y-extension-gb',
      name: 'Home 1-Year Extension',
      description: 'Extend your coverage for an additional year',
      price: 49,
      variantId: 'gid://shopify/ProductVariant/40567890123457',
      SKU: 'HOME-EXT-1Y-GB',
    },
    Year2: {
      id: 'home-2y-extension-gb',
      name: 'Home 2-Year Extension',
      description: 'Extend your coverage for two additional years',
      price: 89,
      variantId: 'gid://shopify/ProductVariant/40567890123458',
      SKU: 'HOME-EXT-2Y-GB',
    },
  },
  [ShopifyStore.AE]: {
    Year1: {
      id: 'home-1y-extension-ae',
      name: 'Home 1-Year Extension',
      description: 'Extend your coverage for an additional year',
      price: 219,
      variantId: 'gid://shopify/ProductVariant/40678901234568',
      SKU: 'HOME-EXT-1Y-AE',
    },
    Year2: {
      id: 'home-2y-extension-ae',
      name: 'Home 2-Year Extension',
      description: 'Extend your coverage for two additional years',
      price: 389,
      variantId: 'gid://shopify/ProductVariant/40678901234569',
      SKU: 'HOME-EXT-2Y-AE',
    },
  },
  [ShopifyStore.AU]: {
    Year1: {
      id: 'home-1y-extension-au',
      name: 'Home 1-Year Extension',
      description: 'Extend your coverage for an additional year',
      price: 69,
      variantId: 'gid://shopify/ProductVariant/40456789012346',
      SKU: 'HOME-EXT-1Y-AU',
    },
    Year2: {
      id: 'home-2y-extension-au',
      name: 'Home 2-Year Extension',
      description: 'Extend your coverage for two additional years',
      price: 119,
      variantId: 'gid://shopify/ProductVariant/40456789012347',
      SKU: 'HOME-EXT-2Y-AU',
    },
  },
  [ShopifyStore.CA]: {
    Year1: {
      id: 'home-1y-extension-ca',
      name: 'Home 1-Year Extension',
      description: 'Extend your coverage for an additional year',
      price: 59,
      variantId: 'gid://shopify/ProductVariant/40345678901235',
      SKU: 'HOME-EXT-1Y-CA',
    },
    Year2: {
      id: 'home-2y-extension-ca',
      name: 'Home 2-Year Extension',
      description: 'Extend your coverage for two additional years',
      price: 99,
      variantId: 'gid://shopify/ProductVariant/40345678901236',
      SKU: 'HOME-EXT-2Y-CA',
    },
  },
  [ShopifyStore.ZA]: {
    Year1: {
      id: 'home-1y-extension-ca',
      name: 'Home 1-Year Extension',
      description: 'Extend your coverage for an additional year',
      price: 59,
      variantId: 'gid://shopify/ProductVariant/40345678901235',
      SKU: 'HOME-EXT-1Y-CA',
    },
    Year2: {
      id: 'home-2y-extension-ca',
      name: 'Home 2-Year Extension',
      description: 'Extend your coverage for two additional years',
      price: 99,
      variantId: 'gid://shopify/ProductVariant/40345678901236',
      SKU: 'HOME-EXT-2Y-CA',
    },
  },
  [ShopifyStore.JP]: {
    Year1: {
      id: 'home-1y-extension-jp',
      name: 'Home 1-Year Extension',
      description: 'Extend your coverage for an additional year',
      price: 8800,
      variantId: 'gid://shopify/ProductVariant/40456789012346',
      SKU: 'HOME-EXT-1Y-JP',
    },
    Year2: {
      id: 'home-2y-extension-jp',
      name: 'Home 2-Year Extension',
      description: 'Extend your coverage for two additional years',
      price: 16000,
      variantId: 'gid://shopify/ProductVariant/40456789012347',
      SKU: 'HOME-EXT-2Y-JP',
    },
  },
  [ShopifyStore.SA]: {},
};

/**
 * Referral discount codes by store
 */
// export const HomeReferralCodes: Record<
//   ShopifyStore,
//   { discountCode: string; discount: number } | undefined
// > = {
//   [ShopifyStore.IN]: { discountCode: 'HOME-REFERRAL', discount: 2000 },
//   [ShopifyStore.ROW]: { discountCode: 'HOME-REFERRAL', discount: 25 },
//   [ShopifyStore.US]: { discountCode: 'HOME-REFERRAL', discount: 25 },
//   [ShopifyStore.SA]: { discountCode: 'HOME-REFERRAL', discount: 25 },
//   [ShopifyStore.MX]: { discountCode: 'HOME-REFERRAL', discount: 25 },
//   [ShopifyStore.EU]: { discountCode: 'HOME-REFERRAL', discount: 25 },
//   [ShopifyStore.GB]: { discountCode: 'HOME-REFERRAL', discount: 20 },
//   [ShopifyStore.AE]: { discountCode: 'HOME-REFERRAL', discount: 90 },
//   [ShopifyStore.AU]: { discountCode: 'HOME-REFERRAL', discount: 30 },
//   [ShopifyStore.CA]: { discountCode: 'HOME-REFERRAL', discount: 25 },
// };
